export default {
  paper: {
    borderRadius: '8px',
    boxShadow: 'none',
    overflow: 'visible',
    width: '300px',
    backgroundColor: 'white',
    height: 200,
  },

  searchInputWrapper: {
    padding: '3px 5px',
    borderBottom: (theme) => `1px solid ${theme.palette.grays?.gray200}`,
  },

  searchIcon: {
    width: '20px',
    color: (theme) => theme.palette.grays.gray400,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 12px',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays?.gray100,
    },
  },

  filterCategoryLabel: {
    fontSize: '14px',
    fontWeight: 400,
    color: (theme) => theme.palette.text.primary,
    flex: 1,
  },

  panelContent: {
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    maxHeight: '500px',
  },
  list: {
    flex: 1,
    overflowY: 'auto',
    padding: '4px',
  },

  itemLabel: {
    fontSize: '14px',
    fontWeight: 400,
    color: (theme) => theme.palette.text.primary,
    flex: 1,
  },
  noResults: {
    padding: '32px 16px',
    textAlign: 'center',
    color: (theme) => theme.palette.grays?.gray700,
    fontSize: '13px',
  },

  textField: {
    width: '100%',
    border: 'none',
    padding: '0',
    '& .MuiOutlinedInput-root': {
      height: '32px',
      fontSize: '14px',
      backgroundColor: 'transparent',
      '& fieldset': { border: 'none' },
    },
    '& .MuiInputBase-root': {
      pl: 0,
    },
  },
};
